// DA-14587: легенда слоя «Ошибки геометрии» — операционные и функциональные зоны
import { i18n } from '@lingui/core';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { onChangeOperationAreaErrType,
    onChangeFunctionalAreaErrType,
    onToggleOpAreaErr,
    onToggleFuncAreaErr,
} from '../../../ac/onChangeMapFilters';
import { OperationAreaErrTypes, FunctionalAreaErrTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendIconRenderer } from '../../LegendRenderer/LegendIconRenderer';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';

const ErrTypeCheckboxes = ({ types, prefix, checkedValues, onChange }) => (
    <div className={styles.checkboxIconGrid}>
        {types.map(({ value, color, label }) => (
            <Fragment key={value}>
                <LegendIconRenderer
                    type={LEGEND_ICON_TYPES.SQUARE}
                    color={color}
                    size="2vw"
                    opacity={0.7}
                />
                <label htmlFor={`${prefix}_${value}`}>{i18n._(label)}</label>
                <div>
                    <label className={styles.switch}>
                        <input
                            type='checkbox'
                            id={`${prefix}_${value}`}
                            value={value}
                            checked={checkedValues.includes(value)}
                            onChange={onChange}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>
            </Fragment>
        ))}
    </div>
);
const AreaErrLegendComponent = ({
    mapFilters,
    onChangeOperationAreaErrType: onChangeOpType,
    onChangeFunctionalAreaErrType: onChangeFuncType,
    onToggleOpAreaErr: onToggleOp,
    onToggleFuncAreaErr: onToggleFunc,
}) => (
    <div>
        <div className={styles.errGroupHeader}>
            <span>{i18n._({ id: 'Операционные зоны', message: 'Операционные зоны' })}</span>
            <label className={styles.switch}>
                <input
                    type='checkbox'
                    checked={mapFilters.opAreaErrEnabled}
                    onChange={onToggleOp}
                />
                <span className={classnames(styles.sliderRound, styles.slider)} />
            </label>
        </div>
        <div className={styles.errGroupItems}>
            <ErrTypeCheckboxes
                types={OperationAreaErrTypes}
                prefix='opAreaErr'
                checkedValues={mapFilters.operationAreaErrTypes}
                onChange={onChangeOpType}
            />
        </div>
        <div className={styles.errGroupHeader}>
            <span>{i18n._({ id: 'Функциональные зоны', message: 'Функциональные зоны' })}</span>
            <label className={styles.switch}>
                <input
                    type='checkbox'
                    checked={mapFilters.funcAreaErrEnabled}
                    onChange={onToggleFunc}
                />
                <span className={classnames(styles.sliderRound, styles.slider)} />
            </label>
        </div>
        <div className={styles.errGroupItems}>
            <ErrTypeCheckboxes
                types={FunctionalAreaErrTypes}
                prefix='funcAreaErr'
                checkedValues={mapFilters.functionalAreaErrTypes}
                onChange={onChangeFuncType}
            />
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, {
    onChangeOperationAreaErrType,
    onChangeFunctionalAreaErrType,
    onToggleOpAreaErr,
    onToggleFuncAreaErr,
})(AreaErrLegendComponent);

export const OperationAreaErrLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Ошибки геометрии'
);
